import { config } from "@config/config";

export const defaultMetaTagData = {
    metaTitle: "Smart Address",
    metaDescription: "Našeptávač adres.",
    fbAppId: config.FACEBOOK_APP_ID,
    image: "", // relative eg. "/static/fb-og-image.jpg"
    keywords: "",
    siteName: "Smart Address",
    type: "website",
    imageWidth: 1200,
    imageHeight: 630,
} as const;
